import React from "react";
import "./Self_Service_Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Self_Service_Banner() {
  return (
    <>
      <section className="Self_Service_Center">
        <Swiper
          spaceBetween={10}
          slidesPerView={1}
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          // autoplay={{ delay: 3000 }}
          loop={true}
          className="Self_Service_Banner_swiper common_swiper"
        >
          <SwiperSlide>
            {" "}
            <div className="img_holder">
              <img
                src="/assets/images/Self_Service_Center/Self_Service_Banner/banne_img_1.png"
                className="banner_img"
                alt="banner"
              />
            </div>
          </SwiperSlide>

          {/* <SwiperSlide>
            {" "}
            <div className="img_holder">
              <img
                src="/assets/images/Self_Service_Center/Self_Service_Banner/banne_img_1.png"
                className="banner_img"
                alt="banner"
              />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            {" "}
            <div className="img_holder">
              <img
                src="/assets/images/Self_Service_Center/Self_Service_Banner/banne_img_1.png"
                className="banner_img"
                alt="banner"
              />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            {" "}
            <div className="img_holder">
              <img
                src="/assets/images/Self_Service_Center/Self_Service_Banner/banne_img_1.png"
                className="banner_img"
                alt="banner"
              />
            </div>
          </SwiperSlide> */}
        </Swiper>
      </section>
    </>
  );
}

export default Self_Service_Banner;
